import {
  paymentMethodDefault,
  paymentMethodUpdate,
  paymentStripeGetPaymentMethods,
  paymentStripeRemovePaymentMethod,
} from '../../routes/api/paths';
import { handleResponse, requestOptions } from '../HandlerService';

/**
 * Contrato esperado del backend:
 *
 * GET /payment-methods
 * Response:
 * {
 *   "data": [
 *     {
 *       "id": "pm_xxx",
 *       "holder_name": "Marcos Guilarte",
 *       "brand": "visa",
 *       "last4": "2524",
 *       "exp_month": 12,
 *       "exp_year": 2026,
 *       "is_default": true,
 *       "provider": "stripe"
 *     }
 *   ]
 * }
 *
 * DELETE /payment-method-delete
 * Body:
 * {
 *   "payment_method_id": "pm_xxx"
 * }
 *
 * POST /payment-method-default
 * Body:
 * {
 *   "payment_method_id": "pm_xxx"
 * }
 *
 * POST /payment-method-update
 * Body:
 * {
 *   "payment_method_id": "pm_xxx",
 *   "holder_name": "Marcos Guilarte",
 *   "exp_month": 12,
 *   "exp_year": 2026
 * }
 */

export const PaymentMethodsListService = async (data) => {
  const { token } = data;
  const options = requestOptions('GET', {}, token);
  return fetch(paymentStripeGetPaymentMethods, options)
    .then(handleResponse)
    .catch((error) => Promise.reject({ status: error }));
};

export const PaymentMethodDeleteService = async (data) => {
  const { token, payment_method_id } = data;
  const options = requestOptions('DELETE', { payment_method_id }, token);
  return fetch(paymentStripeRemovePaymentMethod, options)
    .then(handleResponse)
    .catch((error) => Promise.reject({ status: error }));
};

export const PaymentMethodSetDefaultService = async (data) => {
  const { token, payment_method_id } = data;
  const options = requestOptions('POST', { payment_method_id }, token);
  return fetch(paymentMethodDefault, options)
    .then(handleResponse)
    .catch((error) => Promise.reject({ status: error }));
};

export const PaymentMethodUpdateService = async (data) => {
  const {
    token,
    payment_method_id,
    holder_name,
    exp_month,
    exp_year,
  } = data;

  const options = requestOptions('POST', {
    payment_method_id,
    holder_name,
    exp_month,
    exp_year,
  }, token);

  return fetch(paymentMethodUpdate, options)
    .then(handleResponse)
    .catch((error) => Promise.reject({ status: error }));
};
